// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__sUn3t","container":"Loader_container__bqM32"};